module.exports = __webpack_public_path__ + "b0327981bbaf9c1d7ecd8eaedf067200.pdf";